<template>
  <v-card
      class="ma-2"
  >
    <v-tabs
        v-model="tab"
        bg-color="deep-purple-accent-4"
        centered
        stacked
    >
      <v-tab value="tab-1">
        <v-icon>mdi-code-braces</v-icon>
        Current Projects
      </v-tab>

      <v-tab value="tab-2">
        <v-icon>mdi-progress-wrench</v-icon>
        Projects
      </v-tab>

      <v-tab value="tab-3">
        <v-icon>mdi-school</v-icon>
        School Projects
      </v-tab>

      <v-tab value="tab-4">
        <v-icon>mdi-book-open-blank-variant</v-icon>
        Thesis
      </v-tab>
    </v-tabs>

    <v-window v-model="tab">
      <v-window-item
          v-for="i in 4"
          :key="i"
          :value="'tab-' + i"
      >
        <CurrentProjectsView
            v-if="i === 1"
        />
        <Projects
            v-if="i === 2"
        />
        <SchoolProjects
            v-if="i === 3"
        />
        <ThesisInfo
            v-if="i === 4"
        />
      </v-window-item>
    </v-window>
  </v-card>
</template>

<script>

import ThesisInfo from '@/components/ThesisInfo'
import Projects from '@/components/Projects'
import SchoolProjects from '@/components/SchoolProjects'
import CurrentProjectsView from '@/components/CurrentProjects'

export default {
  name: 'ProjectsTab',
  components: { CurrentProjectsView, ThesisInfo, Projects, SchoolProjects },
  data () {
    return {
      tab: null
    }
  },
  mounted () {
    if (this.$route.path === '/projects/thesis') {
      this.tab = 'tab-4'
    }
  }
}
</script>

<style scoped>

</style>
